// ABOUTME: RTK Query endpoints for the relation-side "nooit verkochte producten" BI report — the
// ABOUTME: paginated grid list and the card totals, both relation-scoped via the injected relation_id header.
import { apiSlice } from "../../createApiSlice";

const BASE = "/products/dashboard/relation/neversold";
const buildUrl = (endpoint) => BASE + endpoint;

const reportRelationNeverSoldSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        // Grid rows — driven by ShDataGrid3 ({ args: { page, size, body } }).
        getNeverSoldList: builder.query({
            query: ({ args }) => ({
                url: buildUrl(`/list?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
        }),
        // Card totals — driven by a { startDate, endDate, staleDays?, noStock? } body.
        getNeverSoldTotals: builder.query({
            query: (body) => ({
                url: buildUrl(`/totals`),
                method: 'POST',
                body,
            }),
        }),
    })
});

export const {
    useGetNeverSoldListQuery,
    useGetNeverSoldTotalsQuery,
} = reportRelationNeverSoldSlice;
